export const typeDefs = `
  input NetworkFilterInput {
    name: String
    rule: String
    search: String
  }

  input NetworkInviteByEmailsInput {
    emails: [String]!
    referralLink: String!
    qrCode: String!
  }
`;
